import {NgModule} from '@angular/core';
import {SharedModule} from '../../app-common/shared.module';
import {searchRoutingComponents, SearchRoutingModule} from './search-routing.module';
import {SharedSerpModule} from './modules/shared-serp.module';

@NgModule({
  imports: [SharedModule, SearchRoutingModule, SharedSerpModule],
  declarations: [searchRoutingComponents],
  providers: [],
  exports: [],
})
export class SearchModule {}
